export const ICON_WHITE = 'white';
export const ICON_BLUE = 'blue';
export const BACKGROUND_NONE = 'background-none';
export const BACKGROUND_RED = 'background-red';
export const BACKGROUND_BLUE = 'background-blue';



// WEBPACK FOOTER //
// ./src/app/shared/slider/slider-custom-icon/constants.ts